import React, { Component } from "react"
import "./userProfileHeader.scss"
import avatarDefault from "../../../../../assets/img/user_avatar.svg"
import bgDefault from "../../../../../assets/img/bg-default.png"
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined"
import EditOutlined from "@material-ui/icons/EditOutlined"
import { Link, withRouter } from "react-router-dom"
import * as routes from "../../../../../library/constants/routes"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { userRolesIds } from "../../../../../library/constants/userRoles"
import {
  getData,
  updateInfo,
} from "../../../../../library/store/actions/creators/authCreators"
import UserProfileControls from "./userProfileControls/userProfileControls"
import ImageModal from "../../../../../components/ui/modals/imageModal/imageModal"
import ImagePickerModal from "../../../../../components/imagePickerModal/imagePickerModal"
import { imageAspectRatios } from "../../../../../library/constants/images"
import {
  composeUserHighlightedEducation,
  composeUserHighlightedWork,
} from "../../../../../library/utils/getUserHighlightedInfo"
import PlainLink from "../../../../../components/ui/link"
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined"
import { PlainButton } from "../../../../../components/v2/controls"
import { getUserBookingLink } from "../../../../../library/utils/user/userUtils"
import { withSnackbar } from "notistack"

class UserProfileHeader extends Component {
  state = {
    avatar: this.props.userInfo.photo
      ? this.props.userInfo.photo
      : avatarDefault,
    bg: this.props.userInfo.background_photo
      ? this.props.userInfo.background_photo
      : bgDefault,
    userInfo: this.props.userInfo,
    type: this.props.type,
    openAvatarFull: false,
    openAvatarUpdate: false,
    openBgUpdate: false,
    uploadProgress: "",
    isUploading: false,
  }

  handleClickOpen = (name) => {
    switch (name) {
      case "avatar":
        this.setState({ openAvatarUpdate: true })
        break

      case "bg":
        this.setState({ openBgUpdate: true })
        break

      case "avatarFull":
        this.setState({ openAvatarFull: true })
        break

      default:
        return
    }
  }

  handleClose = (name) => {
    switch (name) {
      case "avatar":
        this.setState({ openAvatarUpdate: false })
        break

      case "bg":
        this.setState({ openBgUpdate: false })
        break

      case "avatarFull":
        this.setState({ openAvatarFull: false })
        break

      default:
        return
    }
  }

  updateImage = async (img, imgType) => {
    const {
      auth: { userData },
    } = this.props
    switch (imgType) {
      case "avatar":
        this.setState({ avatar: img.cropped_image || avatarDefault })
        await this.props.updateInfo({ full_image: img })
        await this.props.getData(userData.token, userData.id)
        break

      case "bg":
        this.setState({ bg: img.cropped_image || bgDefault })
        await this.props.updateInfo({ full_header: img })
        break

      default:
        break
    }
  }

  render() {
    const { avatar, bg, userInfo, type } = this.state
    const fullName = `${userInfo.first_name} ${userInfo.last_name}`
    // const bgImg = bg !== '' ? {backgroundImage: `url(${bg})`} : {};
    const bgImg =
      bg !== "" ? { backgroundImage: `url(${bg.replace(/ /g, "%20")})` } : {}

    return (
      <div className="profile-container__header box">
        <div className="profile-header user-profile-header">
          <div className="profile-header__top" style={bgImg}>
            <span className="owner-type">
              {userRolesIds[userInfo.role].name || ""}
            </span>
            {type && type === "my-profile" && (
              <div
                className="btn-update-bg"
                onClick={() => this.handleClickOpen("bg")}
              >
                <CameraAltOutlined />
                <span className="btn-update-bg__text">Edit background</span>
              </div>
            )}
          </div>
          <div
            className={`profile-header__bottom profile-header__bottom--has-controls`}
          >
            {type && type === "my-profile" && (
              <div className="absolute top-[15px] right-[15px]">
                <PlainLink to={routes.PROFILE_EDIT} className={"mb-2"}>
                  <EditOutlined />
                  <span className={"ml-1"}>Edit my profile</span>
                </PlainLink>
              </div>
            )}
            <div className="main-user-avatar">
              <img
                src={avatar}
                alt="avatar"
                className="main-user-avatar__img"
                onClick={() => this.handleClickOpen("avatarFull")}
              />
              {type && type === "my-profile" && (
                <div
                  className="main-user-avatar__control"
                  onClick={() => this.handleClickOpen("avatar")}
                >
                  <span className="main-user-avatar__control-text">
                    Edit your photo
                  </span>
                  <CameraAltOutlined />
                </div>
              )}
              <ImageModal
                url={
                  this.props.auth.userData.full_image.original_image ||
                  this.state.avatar
                }
                open={this.state.openAvatarFull}
                handleClose={() => this.handleClose("avatarFull")}
              />
            </div>
            <div className="profile-info">
              <span className="profile-info__name">{fullName}</span>
              <span
                className={`profile-info__secondary ${
                  userInfo.highlighted === 0 ? "mb20" : ""
                }`}
              >
                {userInfo.highlighted === 1 &&
                  !!userInfo.work &&
                  composeUserHighlightedWork(userInfo.work)}
                {userInfo.highlighted === 2 &&
                  !!userInfo.education &&
                  composeUserHighlightedEducation(userInfo.education)}
              </span>
              {type === "my-profile" && (
                <PlainButton
                  onClick={async () => {
                    await navigator.clipboard.writeText(
                      getUserBookingLink(userInfo.id)
                    )
                    this.props.enqueueSnackbar("Data copied to clipboard", {
                      variant: "success",
                    })
                  }}
                >
                  <LinkOutlinedIcon />
                  <span>My booking link</span>
                </PlainButton>
              )}
              {type !== "my-profile" && (
                <UserProfileControls
                  type="user"
                  userInfo={userInfo}
                  onBlacklistModalOpen={this.props.onBlacklistModalOpen}
                  removeFromBlacklist={this.props.removeFromBlacklist}
                  showUserContent={this.props.showUserContent}
                  hideUserContent={this.props.hideUserContent}
                  isBlacklisted={this.props.isBlacklisted}
                  isContentVisible={this.props.isContentVisible}
                />
              )}
            </div>
          </div>
        </div>

        {this.state.openAvatarUpdate && (
          <ImagePickerModal
            // dimensions={{width: 50, x: 20, y: 20}}
            originImage={
              this.props.auth.userData.full_image.original_image ||
              this.state.avatar
            }
            defaultImage={avatarDefault}
            open={this.state.openAvatarUpdate}
            onSave={(full_image) => this.updateImage(full_image, "avatar")}
            onClose={() => this.handleClose("avatar")}
            aspectRatio={imageAspectRatios.square}
            isCircle
          />
        )}

        {this.state.openBgUpdate && (
          <ImagePickerModal
            // dimensions={{width: 50, x: 20, y: 20}}
            originImage={this.state.bg}
            defaultImage={bgDefault}
            open={this.state.openBgUpdate}
            onSave={(full_image) => this.updateImage(full_image, "bg")}
            onClose={() => this.handleClose("bg")}
            aspectRatio={imageAspectRatios.user_page_header}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, person }) => ({ auth, person })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateInfo, getData }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(UserProfileHeader)))
